export default __webpack_public_path__ + "static/media/Loop-of-Codes.d690b219.jpeg";